const SELECTORS = {
    checkoutBtnWrapper: Utility.DomSelector.byId('cart-checkoutbtn'),
    checkoutSticky: Utility.DomSelector.byId('checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {
        if(SELECTORS.checkoutBtnWrapper && SELECTORS.checkoutSticky) this.stickyCheckout();
    }

    // Sticky checkout container on page scroll
    stickyCheckout(){
        Utility.Observer.onChange(
            SELECTORS.checkoutBtnWrapper,
            () => SELECTORS.checkoutSticky.classList.remove('active'),  // onEnter - hide sticky
            () => SELECTORS.checkoutSticky.classList.add('active')      // onExit - show sticky
        );
    }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
